<template>
    <svg
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60"
        class="ml-2">
        <g clip-path="url(#clip0_8061_11342)">
            <path
                d="M2.98438 25.0255H7.89648C7.98359 25.0255 8.06847 25.0491 8.14258 25.0928L8.21289 25.1436L13.3564 29.585C13.4629 29.6769 13.5244 29.8106 13.5244 29.9512V39.002C13.5243 39.1075 13.4899 39.2091 13.4277 39.2921L13.3564 39.3682L8.21289 43.8096C8.12497 43.8856 8.01265 43.9278 7.89648 43.9278H2.98438C2.71704 43.9278 2.5 43.7108 2.5 43.4434V25.5098C2.5 25.2425 2.71704 25.0255 2.98438 25.0255Z"
                stroke="#EEEEEE" />
            <path
                d="M14.1252 28.4087H17.5685C17.8359 28.4087 18.0529 28.6257 18.0529 28.8931V40.2095C18.0528 40.4767 17.8358 40.6929 17.5685 40.6929H14.1252C13.8579 40.6929 13.6409 40.4767 13.6408 40.2095V28.8931C13.6408 28.6591 13.8068 28.4635 14.0275 28.4185L14.1252 28.4087Z"
                stroke="#EEEEEE" />
            <path
                d="M25.6158 23.5L21.6158 23.5L21.6158 17.5L25.6158 17.5L25.6158 23.5Z"
                stroke="#EEEEEE" />
            <path
                d="M48.8766 18.9009C49.4164 18.3641 50.2712 18.3304 50.8503 18.8004L50.9616 18.9009L53.3005 21.2261C53.8388 21.7615 53.8721 22.608 53.4011 23.1822L53.3005 23.2935L49.1979 27.3736L49.0505 27.5201V44.1451C49.0505 44.9558 48.3934 45.6137 47.5827 45.6138H42.488V46.605C42.488 47.4159 41.83 48.0738 41.0192 48.0738H25.779C24.9684 48.0736 24.3112 47.4157 24.3112 46.605V45.6138H19.5368C18.7261 45.6137 18.069 44.9558 18.069 44.1451V24.9566C18.069 24.1459 18.7261 23.489 19.5368 23.4888H44.2634L44.4099 23.3433L48.8766 18.9009Z"
                fill="white"
                fill-opacity="0.05"
                stroke="#EEEEEE" />
            <path
                d="M21.9968 25.9485H45.1218C45.9325 25.9485 46.5903 26.6056 46.5905 27.4163V41.6858C46.5903 42.4964 45.9324 43.1536 45.1218 43.1536H21.9968C21.1863 43.1534 20.5293 42.4963 20.529 41.6858V27.4163C20.5292 26.6057 21.1862 25.9487 21.9968 25.9485Z"
                fill="white"
                fill-opacity="0.05"
                stroke="#EEEEEE" />
            <path
                d="M50.2824 13.8314L49.2722 14.8417C49.0614 15.0524 48.9207 15.3219 48.8668 15.613L48.8489 15.7387L48.5354 18.98C48.4934 19.4164 48.6487 19.8487 48.9587 20.1588L52.0433 23.2434C52.3146 23.5147 52.6797 23.6678 53.0591 23.6736L53.222 23.6667L56.4634 23.3532C56.8024 23.3204 57.1196 23.1707 57.3604 22.9299L58.3707 21.9196C58.9438 21.3463 58.9439 20.4171 58.3707 19.8439L52.3582 13.8314C51.7849 13.2584 50.8557 13.2584 50.2824 13.8314Z"
                stroke="#EEEEEE" />
            <path
                d="M27.901 27.9166H28.3932C29.2039 27.9166 29.8608 28.5737 29.861 29.3844V39.2252C29.861 40.036 29.204 40.693 28.3932 40.693H27.901C27.0903 40.6928 26.4332 40.0359 26.4332 39.2252V29.3844C26.4334 28.5738 27.0905 27.9168 27.901 27.9166Z"
                fill="white"
                fill-opacity="0.05"
                stroke="#EEEEEE" />
            <path
                d="M19.7237 12.1718H40.6651C41.4758 12.1718 42.1337 12.8289 42.1339 13.6396V15.9228C42.1339 16.7336 41.4759 17.3915 40.6651 17.3915H19.7237C18.913 17.3914 18.2559 16.7335 18.2559 15.9228V13.6396C18.2561 12.829 18.9131 12.172 19.7237 12.1718Z"
                stroke="#EEEEEE" />
            <path
                d="M17.7448 31.3527L26.1092 31.3527"
                stroke="#EEEEEE" />
            <path
                d="M8.11584 25L8.11584 44"
                stroke="#EEEEEE" />
            <path
                d="M30.0455 31.3527L49.2345 31.3527"
                stroke="#EEEEEE" />
        </g>
        <defs>
            <clipPath id="clip0_8061_11342">
                <rect
                    fill="white"
                    width="60"
                    height="60" />
            </clipPath>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
